function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from "classnames";
import { withGenericConfig } from "contexts/generic-config-context";
import ExpandArrow from "static/svg/header/expand_arrow_1.svg";
import ArrowRight from "static/svg/arrow-right.svg";
import { trackEvent } from "services/bigbrain-service";
import { HEADER_LEFT_PANEL_ITEM_CLICKED, HEADER_LEFT_PANEL_SUBITEM_CLICKED, HEADER_LEFT_PANEL_SUBITEM_CONTENT_VIEWED } from "constants/bigbrain-event-types";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { useEffect } from "react";
import debounce from "lodash/debounce";
import usePrevious from "client/services/hooks/use-previous";
import HeaderMenuSectionItemComponent from "../../sections-header-menu/header-menu-section-item/header-menu-section-item-component";
import { StyledStructuredHeaderMenuLeftPanelComponent } from "./structured-header-menu-left-panel.scss";
const SUB_ITEM_HOVER_DEBOUNCE_RATE = 1000; // 1sec
const SUB_ITEM_CHANGED_BY = {
    DEFAULT: "default",
    USER: "user"
};
const subItemHoverAction = ({ menuItem, subMenuItem, changedBy })=>{
    trackEvent(HEADER_LEFT_PANEL_SUBITEM_CONTENT_VIEWED, {
        kind: subMenuItem.id,
        info1: menuItem.id,
        info3: changedBy
    });
};
const debounceOnHover = debounce(({ menuItem, subMenuItem, changedBy })=>subItemHoverAction({
        menuItem,
        subMenuItem,
        changedBy
    }), SUB_ITEM_HOVER_DEBOUNCE_RATE);
const StructuredHeaderMenuLeftPanelComponent = (props)=>{
    const { menu, menuId, innerMenuIndex, onItemClick, innerMenuSubIndex, setInnerMenuIndex, setInnerMenuSubIndex, translate, hasSubItems, itemsCollapsedState, enhancedProducts } = props;
    const { bottomItem } = menu;
    const prevInnerMenuSubIndex = usePrevious(innerMenuSubIndex);
    const onLeftPanelItemClick = ({ itemIndex })=>{
        trackEvent(HEADER_LEFT_PANEL_ITEM_CLICKED, {
            kind: menu.items[itemIndex].id,
            info2: menuId,
            info3: itemsCollapsedState[itemIndex]
        });
        onItemClick(itemIndex);
    };
    const onSubItemClick = ({ itemIndex, subItemIndex })=>{
        setInnerMenuSubIndex(subItemIndex);
        trackEvent(HEADER_LEFT_PANEL_SUBITEM_CLICKED, {
            kind: menu.items[itemIndex].subItems[subItemIndex].id,
            info2: menuId
        });
    };
    useEffect(()=>{
        if (hasSubItems(innerMenuIndex)) {
            const changedBy = prevInnerMenuSubIndex === undefined ? SUB_ITEM_CHANGED_BY.DEFAULT : SUB_ITEM_CHANGED_BY.USER;
            debounceOnHover({
                menuItem: menu.items[innerMenuIndex],
                subMenuItem: menu.items[innerMenuIndex].subItems[innerMenuSubIndex],
                changedBy
            });
        }
    }, [
        innerMenuSubIndex,
        innerMenuIndex
    ]);
    const onSubItemHover = ({ itemIndex, subItemIndex })=>{
        setInnerMenuIndex(itemIndex);
        setInnerMenuSubIndex(subItemIndex);
    };
    const renderSubItem = ({ itemIndex, subItem, subItemIndex })=>{
        const { icon, title, subtitle, hasBetaTag } = subItem;
        const Icon = icon;
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("inner-menu-item-subitem", {
                selected: itemIndex === innerMenuIndex && subItemIndex === innerMenuSubIndex
            }),
            onClick: ()=>{
                onSubItemClick({
                    itemIndex,
                    subItemIndex
                });
            },
            onMouseEnter: ()=>{
                onSubItemHover({
                    itemIndex,
                    subItemIndex
                });
            },
            onKeyPress: generateOnKeyDownHandler(()=>onSubItemClick({
                    itemIndex,
                    subItemIndex
                })),
            tabIndex: itemIndex === innerMenuIndex ? 0 : -1,
            children: [
                !enhancedProducts && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "inner-menu-item-subitem-title-and-icon",
                            children: [
                                icon && /*#__PURE__*/ _jsx(Icon, {
                                    className: classnames("inner-menu-item-subitem-title-icon")
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: translate(title)
                                }),
                                hasBetaTag && /*#__PURE__*/ _jsx("div", {
                                    className: "inner-menu-item-subitem-tag",
                                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "inner-menu-item-subitem-title-arrow",
                            children: /*#__PURE__*/ _jsx(ArrowRight, {
                                className: "arrow-icon"
                            })
                        })
                    ]
                }),
                enhancedProducts && /*#__PURE__*/ _jsx("div", {
                    className: "inner-menu-item-subitem-wrapper",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "inner-menu-item-subitem-title-icon-and-arrow",
                        children: [
                            icon && /*#__PURE__*/ _jsx(Icon, {
                                className: classnames("inner-menu-item-subitem-title-icon")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "inner-menu-item-subitem-title-and-subtitle",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "inner-menu-item-subitem-title",
                                        children: translate(title)
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "inner-menu-item-subitem-subtitle",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "inner-menu-item-subitem-title-arrow",
                                children: /*#__PURE__*/ _jsx(ArrowRight, {
                                    className: "arrow-icon"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const isItemArrowPointingDown = (itemIndex)=>hasSubItems(itemIndex) && itemsCollapsedState[itemIndex];
    const isExpandableItem = (itemIndex)=>{
        if (hasSubItems(itemIndex)) {
            return false;
        }
        return true;
    };
    const renderItem = ({ item, itemIndex })=>{
        const isItemSelected = itemIndex === innerMenuIndex;
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("inner-menu-item", {
                selected: isItemSelected,
                collapsed: itemsCollapsedState[itemIndex]
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "inner-menu-item-title",
                    onClick: ()=>onLeftPanelItemClick({
                            itemIndex
                        }),
                    onKeyPress: generateOnKeyDownHandler(()=>onLeftPanelItemClick({
                            itemIndex
                        })),
                    tabIndex: 0,
                    children: [
                        translate(item === null || item === void 0 ? void 0 : item.title),
                        isExpandableItem(itemIndex) && /*#__PURE__*/ _jsx(ExpandArrow, {
                            className: classnames("expand-arrow", {
                                "down-direction": isItemArrowPointingDown(itemIndex)
                            })
                        })
                    ]
                }),
                hasSubItems(itemIndex) && /*#__PURE__*/ _jsx("div", {
                    className: classnames("inner-menu-item-subitems"),
                    children: item.subItems.map((subItem, subItemIndex)=>renderSubItem({
                            itemIndex,
                            subItem,
                            subItemIndex
                        }))
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(StyledStructuredHeaderMenuLeftPanelComponent, {
        className: "structured-header-menu-left-panel",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "structured-header-menu-left-panel-items",
                children: menu.items.map((item, itemIndex)=>renderItem({
                        item,
                        itemIndex
                    }))
            }),
            /*#__PURE__*/ _jsx("div", {
                children: bottomItem && /*#__PURE__*/ _jsx(HeaderMenuSectionItemComponent, _object_spread({}, bottomItem))
            })
        ]
    });
};
export default withGenericConfig(StructuredHeaderMenuLeftPanelComponent);
